<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">أحدث نشرات وأخبار العقارية</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">أحدث نشرات وأخبار العقارية</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->

    <div class="app-content">
      <div class="container-fluid">

        <!-- add button -->
        <div v-if="checkAccess('latestNews_create')" class="row">
          <div class="col text-end">
            <router-link to="/latestNews/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة نشرة
            </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">النشرات والأخبار العقارية</div>
                <span v-if="countRows > 0" class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto">
                  عدد النتائج ( {{ countRows }} )
                </span>
              </div>

              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الصورة</th>
                            <th>العنوان</th>
                            <th>تاريخ النشر</th>
                            <th>ملف PDF</th>
                            <th>الحالة</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>
                              <img :src="MEDIA_URL + row.image" class="img-thumbnail" style="max-width:80px; max-height:60px; object-fit:cover;" alt="">
                            </td>
                            <td>{{ row.title }}</td>
                            <td>{{ row.publishDate }}</td>
                            <td>
                              <a :href="MEDIA_URL + row.pdfFile" target="_blank" class="btn btn-outline-secondary btn-sm">
                                <i class="bi bi-file-earmark-pdf me-1"></i> عرض PDF
                              </a>
                            </td>
                            <td>
                              <span class="badge" :class="row.isActive ? 'bg-success' : 'bg-secondary'">
                                {{ row.isActive ? 'نشط' : 'غير نشط' }}
                              </span>
                            </td>
                            <td>
                              <router-link :to="`/latestNews/update/${row.id}`" class="btn btn-light btn-sm me-2">
                                <i v-if="checkAccess('latestNews_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('latestNews_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)">
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                          <tr v-if="rows.length === 0">
                            <td colspan="7" class="text-center text-muted py-4">لا توجد نشرات بعد</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item">
                        <a class="page-link" href="#" @click.prevent="prevPage()">السابق</a>
                      </li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item">
                        <a class="page-link" href="#" @click.prevent="nextPage()">التالي</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'LatestNewsList',
  data() {
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      pages: [],
      countRows: 0,
    };
  },
  computed: {
    ...mapGetters(['MEDIA_URL']),
  },
  methods: {
    checkAccess,
    getList() {
      this.mainLoading = true;
      this.hasError = false;
      this.$http.get(`/api/admin/latestNews/list?page=${this.currentPage}`).then(({ data }) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index) {
      const deletePrompt = await this.$swal.fire({
        title: 'هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة أخرى ؟',
        showCancelButton: true,
        confirmButtonText: 'حذف',
        cancelButtonText: 'إلغاء',
        confirmButtonColor: '#dc3741',
      });
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/latestNews/delete/${id}`).then(() => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          toast('تم الحذف بنجاح', 'success');
        }).catch(() => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage() { this.currentPage += 1; this.getList(); },
    prevPage() { this.currentPage -= 1; this.getList(); },
    goToPage(num) { this.currentPage = num; this.getList(); },
  },
  created() {
    this.getList();
  },
};
</script>